import { render, staticRenderFns } from "./observed_12.vue?vue&type=template&id=71f7b1cd&scoped=true&"
var script = {}
import style0 from "./observed_12.vue?vue&type=style&index=0&id=71f7b1cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f7b1cd",
  null
  
)

export default component.exports